module.exports = __webpack_public_path__ + "static/media/additional_active.8e1e1928.png";